"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybePrice = exports.priceOrZero = exports.simplifyProductPrice = exports.convertToFormattedPrices = exports.formatPriceWithFractionDigits = exports.formatCTPriceToNumber = exports.localizedDisplayPrice = void 0;
const safeProp_1 = require("../utils/safeProp");
const monet_1 = require("monet");
const prop_1 = __importDefault(require("ramda/src/prop"));
const reduce_1 = __importDefault(require("ramda/src/reduce"));
const locale_1 = require("./locale");
/**
 * Take locale, optional extra params for Intl.NumberFormat, and a price, and
 * return that price as a locale-formatted string
 */
const localizedDisplayPrice = (locale, addtlOptions) => (price) => {
    return (0, locale_1.localeFromString)(locale)
        .chain(locale => (0, safeProp_1.safeProp)(locale, locale_1.localeInfo))
        .chain((0, safeProp_1.safeProp)('currency'))
        .map(currencyCode => new Intl.NumberFormat(locale, {
        currency: currencyCode,
        style: 'currency',
        ...addtlOptions
    }).format(price));
};
exports.localizedDisplayPrice = localizedDisplayPrice;
/** Format CT price into a number with correct cent value  */
const formatCTPriceToNumber = (x) => {
    const fractionDigits = (0, prop_1.default)('fractionDigits', x);
    const dividend = (0, prop_1.default)('centAmount', x);
    const divisor = Math.pow(10, fractionDigits);
    const n = dividend / divisor;
    return Number(Number(n).toFixed(fractionDigits));
};
exports.formatCTPriceToNumber = formatCTPriceToNumber;
/** Format raw number into a number with correct cent value */
const formatPriceWithFractionDigits = (p, fractionDigits = 2) => {
    return Number(p.toFixed(fractionDigits));
};
exports.formatPriceWithFractionDigits = formatPriceWithFractionDigits;
/** Transform array of prices into an object of prices using the currencyCode as keys */
exports.convertToFormattedPrices = (0, reduce_1.default)((acc, price) => {
    const key = (0, prop_1.default)('currencyCode', price);
    return {
        ...acc,
        [key]: (0, exports.formatCTPriceToNumber)(price)
    };
}, {});
/** Format CT price object array into a simplified price */
const simplifyProductPrice = (product) => (0, safeProp_1.safeProp)('masterVariant', product)
    .chain((0, safeProp_1.safeProp)('price'))
    .chain((0, safeProp_1.safeProp)('value'))
    .cata(() => NaN, exports.formatCTPriceToNumber);
exports.simplifyProductPrice = simplifyProductPrice;
const priceOrZero = (rawPrice) => rawPrice
    ? (0, exports.formatCTPriceToNumber)(rawPrice)
    : 0;
exports.priceOrZero = priceOrZero;
const maybePrice = (rawPrice) => rawPrice
    ? (0, monet_1.Just)((0, exports.formatCTPriceToNumber)(rawPrice))
    : (0, monet_1.None)();
exports.maybePrice = maybePrice;
//# sourceMappingURL=price.js.map